import { APICore } from "./apiCore";
const api = new APICore();

const getWorkScheduleList = (params)  => {
    const baseUrl = `work_schedule/list`;
    return api.get(`${baseUrl}`, params);
}

const getWorkScheduleShiftNameList = (params) => {
    const baseUrl = `work_schedule/shift_names`;
    return api.get(`${baseUrl}`, params);
}

const getWorkScheduleByDayOfWeekList = (params) => {
    const baseUrl = `work_schedule/by_day_of_week`;
    return api.get(`${baseUrl}`, params);
}

const getWorkScheduleByDay = (day) => {
    const baseUrl = `work_schedule/by_day/${day}`;
    return api.get(`${baseUrl}`);
}

const getWorkScheduleOption = (params) => {
    const baseUrl = `work_schedule/options`;
    return api.get(`${baseUrl}`, params);
}

const getWorkScheduleByShift = (dayname) => {
    const baseUrl = `work_schedule/by_shift/${dayname}`;
    return api.get(`${baseUrl}`);
}

export { getWorkScheduleList, getWorkScheduleShiftNameList, getWorkScheduleByDayOfWeekList, getWorkScheduleByDay, getWorkScheduleOption, getWorkScheduleByShift }